export const PlanningType = {
    INCLUSION: 'inclusion',
    EXCLUSION: 'exclusion',
};
